import React from "react";

import PageAncestor from "core/common/page/pageAncestor";
import mdEntityService from "core/metamodel/mdEntityService";
import {MODULE, PageProps} from "core/metamodel/metaConstant";
import "invoice/page/invoiceDetail.less";
import {observer} from "mobx-react";
import {ObservableMap} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {loc} from "core/common/config/locales";

import 'flag-icon-css/css/flag-icon.css';
import {SubCriterion} from "../../domain/criterion/subCriterionDomain";
import sbToolCriterionService from "../../service/criterionService";
import gridService from "../../../core/grid/gridService";
import Grid, {GridLocation} from "../../../core/grid/domain/grid";
import {MovingBlocks} from "../../../core/grid/gridUtils";
import GridComp, {UILOCATION} from "../../../core/grid/component/gridComp";
import {SUB_CRITERION_PARAM_VALUES_LIST} from "../../gridsContants";
import {SUB_CRITERION_ENTITY} from "../../entityConstants";

@observer
export default class SbToolSubCriterionDetail extends PageAncestor<PageProps, undefined> {

  static module = MODULE.sbtool;
  static title = loc.i18n`Sub-criterion`;
  static icon = 'list';
  static protectedPage = true;


  static fetchData(routerParams, query) {
    console.log("SbToolSubCriterionDetail#fetchData(%O)", query);


    let metadataPromise = mdEntityService.fetchEntityMetadata([SUB_CRITERION_ENTITY]);
    let criterionPromise: Promise<SubCriterion> = sbToolCriterionService.readSubCriterion(routerParams.id)
    let gridPromise = gridService.fetchGrids(SUB_CRITERION_PARAM_VALUES_LIST);

    return Promise.all([metadataPromise, criterionPromise, gridPromise])
      .then(([entityMap, subcriterion, gridLocationMap]: [ObservableMap<MdEntity>, SubCriterion, ObservableMap<GridLocation>]) => {
        sbToolCriterionService.subCriterionObject = subcriterion;

        sbToolCriterionService.subCriterionObject.$movingBlocks = new MovingBlocks(SUB_CRITERION_PARAM_VALUES_LIST, true, query.tab,
          new Grid(gridLocationMap.get(SUB_CRITERION_PARAM_VALUES_LIST), sbToolCriterionService.subCriterionObject.subCriterionId),
        );

        sbToolCriterionService.subCriterionObject = subcriterion.initAfterRead(false);
      })
  }

  componentDidUpdate(prevProps: PageProps) {
    if(this.idChanged(prevProps.params.id, this.props.params.id)) {
      sbToolCriterionService.subCriterionObject.$movingBlocks.searchExposedGrids(sbToolCriterionService.subCriterionObject);
    }
  }

  componentDidMount() {
    console.debug("%c componentDidMount", "background-color: magenta");
    sbToolCriterionService.subCriterionObject.$movingBlocks.searchExposedGrids(sbToolCriterionService.subCriterionObject);
  }

  componentWillUnmount() {
    sbToolCriterionService.subCriterionObject = null;
  }

  findRootObject() {
    return sbToolCriterionService.subCriterionObject;
  }



  render() {
    let criterion: SubCriterion = sbToolCriterionService.subCriterionObject
    let paramsValuesGrid : Grid = criterion.$movingBlocks.getBlock(SUB_CRITERION_PARAM_VALUES_LIST) as Grid;
    return (
      <main className="main-content" style={{display: 'flex', flexDirection: 'column'}}>
        <div style={{marginLeft : 20}}>
          <h4>{criterion.name}</h4>
          {criterion.description}
        </div>
        <GridComp grid={paramsValuesGrid} uiLocation={UILOCATION.main} entities={mdEntityService.entityMap} hideGridConfig hideCopyRow/>
      </main>
    );
  }


}




// WEBPACK FOOTER //
// ./src/sbtool/page/criterion/subCriterionDetail.tsx